import { SlideDrawer } from "@/components/ui/slide-drawer";
import { DecisionTester } from "@/components/admin/decisions/DecisionTester";
import type { CaseContextField } from "@/types/decision-editor";

interface DecisionTestDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  decisionId: string;
  decisionJson?: string;
  caseContextSchema: CaseContextField[];
}

export function DecisionTestDrawer({
  isOpen,
  onClose,
  decisionId,
  decisionJson,
  caseContextSchema,
}: DecisionTestDrawerProps) {
  return (
    <SlideDrawer isOpen={isOpen} onClose={onClose}>
        <div className="px-6 pt-6 pb-2 border-b border-slate-100">
          <h2 className="text-lg font-semibold leading-none tracking-tight">Test Decision</h2>
          <p className="text-sm text-muted-foreground mt-1.5">
            Provide input facts and evaluate the decision tree
          </p>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          <DecisionTester
            decisionId={decisionId}
            decisionJson={decisionJson}
            caseContextSchema={caseContextSchema}
          />
        </div>
    </SlideDrawer>
  );
}
